export default __webpack_public_path__ + "media/570815d261a16f90c00ce740f088d085cdb37ae00281e184c2792f0abdee0c05.svg";